import { render, staticRenderFns } from "./AppCidadaoPrestadores.vue?vue&type=template&id=339cf8fe&scoped=true&"
import script from "./AppCidadaoPrestadores.vue?vue&type=script&lang=js&"
export * from "./AppCidadaoPrestadores.vue?vue&type=script&lang=js&"
import style0 from "./AppCidadaoPrestadores.vue?vue&type=style&index=0&id=339cf8fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "339cf8fe",
  null
  
)

export default component.exports